import React from 'react';
import { isProduction } from '@src/utils/env';
import ReferralEmbed from './ReferralEmbed';
import ReferralPopup from './ReferralPopup';

type ReferralContainerProps = {
  isPopup?: boolean;
};

export const ReferralContainer = ({ isPopup = false }: ReferralContainerProps) => {
  const urlNumber = isProduction() ? 35526 : 36063;
  const url = `p/${urlNumber}/w/referrerWidget`;

  return isPopup ? <ReferralPopup url={url} /> : <ReferralEmbed url={url} />;
};
